/**
 * @description 替代 numeral.js 的数字格式化方法。 根据项目内目前的调用场景， 实现最小功能集。
 */
function formatNumber({
  number = 0,
  format,
  sign = false
}: {
  number?: number | string
  format: string
  sign?: boolean
}) {
  const isInvalidNum = isInvalid(number)
  if (isInvalidNum) return ''

  const num = Number(number)
  const formattedNumber = getFormatter(decimalsFrom(format)).format(num)
  return sign && num >= 0 ? `+${formattedNumber}` : formattedNumber
}
/**校验参数number是否是有效的数字，认为是无效的话返回空字符串 */
function isInvalid(n: number | string): boolean {
  const isEmptyStr = typeof n === 'string' && n.trim() === ''
  const toNumber = Number(n)
  return Number.isNaN(toNumber) || toNumber === Infinity || toNumber === -Infinity || isEmptyStr
}

/** 解析 '0,0.00' 这一格式要求的小数位；不匹配视为 0 位； 去掉首尾的空格*/
function decimalsFrom(format: string): number {
  return format.match(/^\s*0,0(?:\.([0]+))?\s*$/)?.[1]?.length ?? 0
}

/**
 * 缓存不同小数位数对应的 Intl.NumberFormat（固定 en-US）。
 * 为什么要缓存？为什么要缓存？ 潜在的性能问题。当长列表或者动画，高频调用有额外的查询开销
 */
const fmtCache = new Map<number, Intl.NumberFormat>()
/**
 * 最大最小小数位数通过传入的format参数决定
 */
function getFormatter(digits: number): Intl.NumberFormat {
  let fmt = fmtCache.get(digits)
  if (!fmt) {
    fmt = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    })
    fmtCache.set(digits, fmt)
  }
  return fmt
}
/** 工厂函数，导出易用预设函数 */
function createFormatter(defaultFormat: string) {
  return (args: { number?: number | string; sign?: boolean; format?: string }) =>
    formatNumber({ ...args, format: args.format ?? defaultFormat })
}
/**
 * 标准数字格式化 使用en-US千分位，默认保留两位小数
 * 可以通过显式传递format参数控制小数位数: 仅支持 '0,0' / '0,0.0...' 也就是仅小数位数可配置
 */
export const formatNum = createFormatter('0,0.00')
